<template>
  <div class="content" v-if="this.$route.query.cc" style="background-color: #fafafa;" v-show="showPage">
    <div class="mod">
      <div class="box">
        <div class="submain">
          <img class="icon_12" src="/static/img/authentication4.png"/>
          <img class="pic" src="/static/img/authentication11.png"/>
          <img class="largeIcon" src="/static/img/authentication9.png"/>
          <img class="icon_13" src="/static/img/authentication4.png"/>
          <span class="summary">在支付宝中使用E签宝小程序，根据提示完成人脸识别，并签署合同</span>
<!--          <span class="summary">在支付宝中使用E签宝小程序，根据提示完成人脸识别，并签署<span style="color:#5878FA;">《淘基因用户订购协议》</span></span>-->
          <span class="desc_1"></span>
          <img class="img" src="/static/img/authentication10.png"/>
          <span class="word_1"></span> <span class="text"></span>
          <span class="info_3"></span>
          <span class="word_2"></span>
          <span class="info_4">打开短信中的链接，点击<span style="color: #5878FA">「快捷签署」</span>，跳转支付宝<span style="color:#FE654D">（未开通支付宝请咨询客服进行人工认证）</span></span>
          <span class="info_5"> <span style="color: #5878fa;">点击发起签署</span> <span style="font-size: 14px;
    font-weight: 400;">，认证链接会以短信形式发送到您的手机上</span></span>
          <div style="position: absolute;top: 30px;margin-left: 70px;">
            <span style="padding-right: 12px">
              <img style=" width: 27px;height: 2px;margin-bottom: 3px;color: #D2D2D6" src="/static/img/authentication1.png"/>
            </span>
            <span style="line-height: 21px; white-space: nowrap;color: #424242;font-size: 21px;font-weight: 500; ">
            合同签署流程
            </span>
             <span style="padding-left: 12px">
              <img style=" width: 27px;
    height: 2px;    margin-bottom: 3px;color: #D2D2D6" src="/static/img/authentication1.png"/>
           </span>
          </div>
        </div>
        <div class="row">
          <img style="background:#d2d2d6;width: 15px;
height: 1px;" class="icon_14" src="/static/img/authentication1.png"/>
          <span class="info_7">我是有底线的</span>
          <img style="
background:#d2d2d6;width: 15px;
height: 1px;" class="icon_15" src="/static/img/authentication1.png"/>
        </div>
        <div class="footer">
          <div class="footer-content">
            <div style="width: 100%;">
              <div class="add-btn research-background-color" @click="go" style="padding-top: 10px">开始签署合同</div>
            </div>
          </div>
          <footer-placeholder></footer-placeholder>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
  <div class="content" style="background-color: white" v-if="isSpecialPromotion">
    <div>
      <img
        style="height: 100%;width: 100%;"
        :src="baseurl + 'c276.png'"
        @click="goToSpecialPromotion"
      >
    </div>
  </div>
    <div class="content" style="background-color: white" v-else-if="$route.query.isadvertising" >
      <div>
        <a href="https://genechem.jinshuju.net/f/S85ziR" target="_blank" v-if="openLink()">
          <img style="height: 100%;width: 100%;"  :src="baseurl + $route.query.detailImageUrl">
        </a>
        <a href="https://jinshuju.net/f/ZV4SUF" target="_blank" v-else-if="openLink2()">
          <img style="height: 100%;width: 100%;"  :src="baseurl + $route.query.detailImageUrl">
        </a>
        <a href="https://jinshuju.net/f/nrxuBV" target="_blank" v-else-if="openLink3()">
          <img style="height: 100%;width: 100%;"  :src="baseurl + $route.query.detailImageUrl">
        </a>
        <img style="height: 100%;width: 100%;"  :src="baseurl + $route.query.detailImageUrl" v-else @click="goToActivity()">
      </div>
    </div>
    <div class="content" style="background-color: white"  v-else >
      <div style="margin-bottom: 2.5rem" v-if="!isWapp">
        <nav class="bar bar-nav">
          <a class="button button-link button-nav pull-left"  @click="gotolast()">
            <span class="icon icon-left"></span>返回
          </a>
        </nav>
      </div>
      <div>
        <div  style="margin-bottom: 10px" v-if="$route.query.detailImageUrl && openLink() " >
          <a href="https://genechem.jinshuju.net/f/S85ziR" target="_blank">
            <img style="height: 100%;width: 100%;"  :src="baseurl + $route.query.detailImageUrl">
          </a>
        </div>
        <div  style="margin-bottom: 10px" v-if="$route.query.detailImageUrl && !openLink() " @click="checkForCouponActivity()" >
          <img  style="height: 100%;width: 100%;"  :src="baseurl + $route.query.detailImageUrl"   >
        </div>
        <div >
          <div style="margin-bottom: 0.6rem;" v-if="coupons && !$route.query.activityId" v-for="tabs in coupons"  >
            <div>
              <img   style="margin-left: 0.5rem;height:100%;width: 100%" :src="baseurl + tabs.imageUrl"  @click="getcoupon(tabs)" >
            </div>
          </div>
          <div style="margin-bottom: 0.6rem;" v-if="bcoupons && !$route.query.activityId" v-for="ctabs in bcoupons"  >
            <table border="0" cellpadding="0" cellspacing="0" width="100%"  >
              <tr>
                <td>
                  <img   style="height:100%;clear: both;display: block;margin:auto;" :src="baseurl + ctabs.imageUrl"  @click="getcoupon(ctabs)" >
                  </img>
                </td>
              </tr>
            </table>
          </div>
          <div>
          </div>
          <div class="search-input" style="margin-left: 0.5rem;margin-right: 0.5rem;margin-top: 0.5rem">
            <label class="icon icon-search" for="search"></label>
            <input type="search" id='search'  class="open-popup open-goods" data-popup=".popup-goods" placeholder='输入商品...' readonly unselectable="on"/>
          </div>
        </div>
        <newMerchandiseListA :merchList="merchandise" :description="$route.query.des" :channel="$route.params.channel"></newMerchandiseListA>
        <div v-if="merchandise.length>10" class="button"  @click="loadmore">更多...</div>
        <div id="over" style="text-align: center;"></div>
      </div>



    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import {mapGetters, mapState} from 'vuex'
  import merchdata from '../../components/MerchandiseList.vue'
  import newMerchandiseListA from '../finder/components/NewMerchandiseListA'
  import FooterPlaceholder from '../../views_v_2.6/components/FooterPlaceholder.vue'
  import emkt from '../../emkt.js'
  import wx from 'wx'
  export default {
    data () {
      return {
        orderId: this.$route.query.orderId,
        merchandise: [],
        total: 0,
        baseurl: 'emktResources/resocurces/img/promotion/',
        coupons: [],
        bcoupons: [],
        channel: {},
        showPage: false,
        CanStartAuthentication: false,
        authenticationDetail: null,
        activityRedirectPath: '',
        activityType: null
      }
    },
    created () {
      if (this.$route.query.cc) {
        this.checkOrderStatus()
      }
      this.fetchData()
      if (this.$route.query.activityId) {
        this.getActivityPath()
      }
      console.log('isSpecialPromotion', this.isSpecialPromotion)
    },
    components: {
      merchdata, newMerchandiseListA, FooterPlaceholder
    },
    computed: {
      ...mapGetters([
        'hasLogin', 'isWapp'
        // ...
      ]),
      ...mapState([
        'sessionInfo'
      ]),
      isSpecialPromotion () {
        return this.$route.query.id === 'promotion-C-275'
      }
    },
    methods: {
      goToSpecialPromotion () {
        const customerInfo = this.sessionInfo && this.sessionInfo.customerInfo
        if (!customerInfo) {
          this.$weui.toast('未获取到用户信息，请先登录后重试', 2500)
          return
        }
        const params = new URLSearchParams({
          customerNo: customerInfo.customerNo || '',
          customerName: customerInfo.customerName || '',
          customerMobile: customerInfo.mobile || '',
          customerSession: customerInfo.session || ''
        })
        window.location.href = `https://www.genechemat.com/worldcup/?${params.toString()}`
      },
      checkOrderStatus () {
        if (!this.sessionInfo.customerInfo) {
          return
        }
        this.authenticationDetail = {
          'customerName': this.sessionInfo.customerInfo.customerName,
          'orderId': this.orderId
        }
        // 获取最新的客户信息
        this.gcapi('gcwwwifc/getCustomerWithoutLogin?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(response => {
          if (response.body.result) {
            this.authenticationDetail = {
              'customerName': response.body.result.customerName,
              'orderId': this.orderId
            }
          }
          this.gcapi('getWaitPayOrderInfoByOrderId', parseInt(this.$route.query.orderId)).then(res => {
            if (res.body.code === 0) {
              let signStatus = res.body.result.signStatus
              if (signStatus === 2) {
                this.$router.replace({name: 'PromotionSuccess', query: {orderId: this.orderId}})
              } else if (signStatus === 1) {
                this.$router.replace({name: 'sendAuthentication', params: {authenticationInfo: this.authenticationDetail}, query: {orderId: this.orderId, time: 60}})
              } else {
                this.fetchData()
                this.showPage = true
              }
            } else {
              alert('获取电签状态失败，请检查你的网络或联系客服！')
            }
          })
        })
      },
      goStartAuthentication (customerNo) {
        if (!this.hasLogin) {
          $.toast('请先登录')
          this.$router.push({name: 'login'})
        } else {
          this.$router.replace({name: 'authenticationHome', query: {orderId: this.orderId, customerNo: customerNo}})
        }
      },
      sendAuthentication () {
        var _this = this
        _this.$weui.loading('正在发送短信')
        _this.gcapi('startEmktSignFlowByCustomer', this.authenticationDetail)
          .then((response) => {
            _this.$weui.loading().hide()
            if (response.body.message !== '') {
              _this.$weui.toast(response.body.message, 3000)
            } else {
              _this.$weui.toast('短信已经发送！', 3000)
              _this.$router.replace({name: 'sendAuthentication', params: {authenticationInfo: this.authenticationDetail}, query: {orderId: this.orderId, time: 60}})
            }
          }, (response) => {
            console.log(response.body.message)
            _this.$weui.toast(response.body.message, 2500)
          })
      },
      go () {
        console.log(this.sessionInfo)
        this.$weui.loading('正在获取信息')
        this.gcapi('getSignCustomerInfo', this.orderId).then((res) => {
          console.log(res.body)
          let result = res.body.result
          if (result) {
            if (result.authenticationInfo && result.authenticationInfo.length > 0) {
              this.sendAuthentication()
            } else {
              this.$weui.loading().hide()
              this.goStartAuthentication(result.customerNo)
            }
          }
        })
      },
      fetchData () {
        if (this.$route.query.id === '') {
          if (emkt.getLocalStorage('EmktRecommendations') && emkt.getLocalStorage('EmktRecommendations').length > 0) {
            this.merchandise = emkt.getLocalStorage('EmktRecommendations')
          } else {
            this.merchandise = emkt.getLocalStorage('EmktAllRecommends')
          }
        } else if (this.$route.query.promotionGroupGuid) {
          var channel = {}
          var channelList = emkt.getLocalStorage('EmktChannels')
          for (var m = 0; m < channelList.length; m++) {
            if (this.$route.query.promotionGroupGuid === channelList[m].promotionGroupGuid) {
              channel = channelList[m]
            }
          }
          this.channel = channel
          if (channel.promotionList.length === 1) {
            this.gcapi('queryMerchandise', {promotionGuid: channel.promotionList[0].promotionGuid, fromIndex: 0}).then((response) => {
              this.merchandise = response.body.result.merchandiseList
              this.total = response.body.result.total
            })
          }
        } else {
          this.gcapi('queryMerchandise', {promotionGuid: this.$route.query.id, fromIndex: 0}).then((response) => {
            this.merchandise = response.body.result.merchandiseList
            this.total = response.body.result.total
          })
          if (this.$route.query.type === 6) {
            this.gcapi('getSeckillPromotion', this.$route.query.id).then((response) => {
              console.log(response.body.result)
            })
          }
          /*
          this.gcapi('getApplicableMerchandiseLiteList', this.$route.query.id).then((response) => {
            this.merchandise = response.body.result
          })
          */
        }
        var Promotions = []
        Promotions = emkt.getLocalStorage('EmktPromotions')
        for (var i = 0; i < Promotions.length; i++) {
          if (Promotions[i].promotionGuid === this.$route.query.id) {
            // var newcoupons = []
            // var oldcoupons = []
            // oldcoupons = Promotions[i].couponTemplateList
            // if (oldcoupons) {
            //   for (var k = 0; k < oldcoupons.length; k++) {
            //     if (oldcoupons[k].type === 0) {
            //       this.bcoupons.push(oldcoupons[k])
            //     } else {
            //       newcoupons.push(oldcoupons[k])
            //     }
            //   }
            // }
            // for (var j = 0; j < newcoupons.length; j = j + 3) {
            //   var tabs2 = []
            //   tabs2.push(newcoupons[j])
            //   tabs2.push(newcoupons[j + 1])
            //   tabs2.push(newcoupons[j + 2])
            //   this.coupons.push(tabs2)
            // }
            this.coupons = Promotions[i].couponTemplateList
          }
        }
        // if (this.$route.query.id === emkt.AuthenticationID && this.hasLogin) {
        //   this.gcapi('gcwwwifc/getCustomerWithoutLogin?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(response => {
        //     if (response.body.result) {
        //       if (!response.body.result.authenticationInfo) {
        //         this.CanStartAuthentication = false
        //       } else {
        //         this.CanStartAuthentication = true
        //         // self.$weui.toast('您已实名认证过！', 2500)
        //       }
        //     } else {
        //       this.$weui.toast(response.body.message, 1500)
        //     }
        //   })
        // }
      },
      getcoupon (data) {
        var self = this
        if (!self.hasLogin) {
          if (emkt.isWapp) {
            self.$weui.confirm('请先登录再来领取优惠！', {
              title: '提示',
              buttons: [{
                label: '取消',
                type: 'default',
                onClick: function () { console.log('no') }
              }, {
                label: '去登录',
                type: 'primary',
                onClick: function () {
                  const wappLoginType = emkt.getFullUrlParam('LoginType')
                  const pages = wappLoginType === emkt.WAPP_LOGIN_TYPE_CODE ? emkt.WAPP_LOGIN_TYPE_DICTIONARY[emkt.WAPP_LOGIN_TYPE_CODE] : emkt.WAPP_LOGIN_TYPE_DICTIONARY[emkt.WAPP_LOGIN_TYPE_WX]
                  wx.miniProgram.navigateTo({
                    url: pages
                  })
                }
              }]
            })
          } else {
            self.$weui.alert('请您先登录~')
            this.$router.push({name: 'login'})
          }
        } else {
          $.confirm('您确定领取此优惠券吗？',
            function () {
              self.gcapi('requestCoupon', {promotionGuid: data.promotionGuid, code: data.code}).then((response) => {
                $.toast(response.body.result)
                console.log(response.body.result)
              })
//            requestCoupon(data)
            },
            function () {
              console.log('cancel')
            })
        }
      },
      loadmore () {
        var fromindex = this.merchandise.length
        if (fromindex >= this.total) {
          $('.button').remove()
          $('#over').append('已经到底啦！')
          return
        } else {
          var addlist = []
          if (this.channel.promotionList && this.channel.promotionList.length === 1) {
            this.gcapi('queryMerchandise', {promotionGuid: this.channel.promotionList[0].promotionGuid, fromIndex: fromindex}).then((response) => {
              addlist = response.body.result.merchandiseList
              for (var i = 0; i < addlist.length; i++) {
                this.merchandise.push(addlist[i])
              }
            })
          } else {
            this.gcapi('queryMerchandise', {promotionGuid: this.$route.query.id, fromIndex: fromindex}).then((response) => {
              addlist = response.body.result.merchandiseList
              for (var i = 0; i < addlist.length; i++) {
                this.merchandise.push(addlist[i])
              }
            })
          }
        }
      },
      tolast () {
        this.$router.go(-1)
      },
      gotolast () {
        this.$router.push({name: 'home'})
      },
      openLink () {
        const promotionId = this.$route.query.id
        if (promotionId.includes('20210318-004')) {
          return true
        }
        return false
      },
      openLink2 () {
        const promotionId = this.$route.query.id
        if (promotionId.includes('-154')) {
          return true
        }
        return false
      },
      openLink3 () {
        const promotionId = this.$route.query.id
        if (promotionId.includes('-161')) {
          return true
        }
        return false
      },
      goToActivity () {
        const promotionId = this.$route.query.id
        if (promotionId.includes('-169')) {
          return this.$router.push({name: 'ActivityDoctor'})
        }
        return
      },
      async getActivityPath () {
        const activityTypeRes = await this.gcapi('couponActivityById', parseInt(this.$route.query.activityId))
        console.log('activityTypeRes', activityTypeRes)
        this.activityType = activityTypeRes && activityTypeRes.body.result && activityTypeRes.body.result.activityType
        let activityPath
        switch (this.activityType) {
          case emkt.COUPON_ACTIVITY_TYPE_COUPON:
            activityPath = '/pages/coupon/index'
            break
          case emkt.COUPON_ACTIVITY_TYPE_GROUP_BUY:
            activityPath = '/pages/coupon/group-coupon/index'
            break
          case emkt.COUPON_ACTIVITY_TYPE_ANNIVERSARY:
            activityPath = '/Weapp/activity/anniversary'
            break
          default:
            activityPath = '/pages/coupon/index'
        }
        this.activityRedirectPath = `${activityPath}?activityId=${this.$route.query.activityId}`
        console.log('activityPath:', this.activityRedirectPath)
      },
      goToActivityDetailPage () {
        if (this.activityType === emkt.COUPON_ACTIVITY_TYPE_ANNIVERSARY) {
          this.$router.push(this.activityRedirectPath)
        } else if (emkt.isWapp) {
          wx.miniProgram.navigateTo({
            url: self.activityRedirectPath
          })
        }
      },
      checkForCouponActivity () {
        var self = this
        console.log('self.$route', self.$route)
        if (self.$route.query.activityId) {
          if (!self.hasLogin) {
            if (emkt.isWapp) {
              this.goToActivityDetailPage()
              // self.$weui.confirm('请先登录再来领取优惠！', {
              //   title: '提示',
              //   buttons: [{
              //     label: '取消',
              //     type: 'default',
              //     onClick: function () { console.log('no') }
              //   }, {
              //     label: '去登录',
              //     type: 'primary',
              //     onClick: function () {
              //       const wappLoginType = emkt.getFullUrlParam('LoginType')
              //       const pages = wappLoginType === emkt.WAPP_LOGIN_TYPE_CODE ? emkt.WAPP_LOGIN_TYPE_DICTIONARY[emkt.WAPP_LOGIN_TYPE_CODE] : emkt.WAPP_LOGIN_TYPE_DICTIONARY[emkt.WAPP_LOGIN_TYPE_WX]
              //       wx.miniProgram.navigateTo({
              //         url: pages
              //       })
              //     }
              //   }]
              // })
            } else {
              self.$weui.alert('请您先登录~')
              this.$router.push({name: 'login'})
            }
          } else {
            this.goToActivityDetailPage()
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mod {
    height: 100vh;
    width: 100%;
  }

  .box {
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #fafafa;
    overflow: hidden;
    width: 100%;
    padding: 10px;
  }
  .submain {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 10px;
    border-radius: 10px;
    border: 1px solid #EFEEF3;
    background-color: #ffffff;
    width: 100%;
    height: 390px;
  }

  .icon_12 {
    position: absolute;
    top: 44px;
    right: 72px;
    width: 27px;
    height: 2px;
  }

  .pic {
    position: absolute;
    top: 140px;
    right: 30px;
    width: 98px;
    height: 141px;
  }

  .largeIcon {
    position: absolute;
    top: 37px;
    left: 15px;
    width: 79px;
    height: 141px;
  }

  .icon_13 {
    position: absolute;
    top: 44px;
    left: 73px;
    width: 27px;
    height: 2px;
  }

  .info_2 {
    position: absolute;
    right: 67px;
    bottom: 33px;
    line-height: 15px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 14px;
    font-weight: 600;
  }

  .summary {
    webkit-box-orient: vertical;
    display: -webkit-inline-box;
    webkit-line-clamp: 2;
    position: absolute;
    top: 297px;
    right: 16px;
    width: 206px;
    height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    color: #424242;
    font-size: 14px;
    font-weight: 400;
  }

  .desc_1 {
    webkit-box-orient: vertical;
    display: -webkit-inline-box;
    webkit-line-clamp: 2;
    position: absolute;
    top: 231px;
    left: 60px;
    width: 140px;
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    color: #fe654d;
    font-size: 14px;
    font-weight: 400;
  }

  .img {
    position: absolute;
    bottom: 0;
    left: 21px;
    width: 99px;
    height: 141px;
  }

  .word_1 {
    position: absolute;
    top: 231px;
    left: 15px;
    line-height: 20px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 400;
  }

  .text {
    position: absolute;
    top: 211px;
    right: 150px;
    line-height: 20px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 400;
  }

  .info_3 {
    position: absolute;
    top: 211px;
    left: 15px;
    line-height: 20px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 14px;
    font-weight: 600;
  }

  .word_2 {
    position: absolute;
    top: 191px;
    right: 149px;
    line-height: 20px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 14px;
    font-weight: 600;
  }

  .info_4 {
    position: absolute;
    top: 190px;
    left: 15px;
    width: 191px;
    height: 80px;
    line-height: 20px;
    word-break: break-all;
    white-space: normal;
    color: #424242;
    font-size: 14px;
    font-weight: 400;
  }


  .info_5 {
    position: absolute;
    top: 101px;
    left: 108px;
    line-height: 20px;
    word-break: break-all;
    white-space: normal;
    font-size: 14px;
    font-weight: 600;
  }

  .info_6 {
    position: absolute;
    top: 30px;
    right: 114px;
    line-height: 29px;
    white-space: nowrap;
    color: #424242;
    font-size: 21px;
    font-weight: 500;
  }

  .row {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 10px;
    height: 17px;
  }

  .icon_14 {
    margin-top: 1px;
    margin-right: 8px;
    width: 15px;
    height: 2px;
  }

  .info_7 {
    margin-right: 8px;
    line-height: 12px;
    white-space: nowrap;
    color: #d2d2d6;
    font-size: 12px;
    font-weight: 400;
  }

  .icon_15 {
    margin-top: 1px;
    width: 15px;
    height: 2px;
  }

  .row1 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 15px;
    position: fixed;
    bottom: 0;
  }

  .div {
    position: relative;
    width: 375px;
    height: 0;
  }

  .normal_div_7 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 1px;
    width: 375px;
  }

  .bg {
    position: relative;
    margin-top: -1px;
    width: 375px;
    height: 1px;
  }

  .block_9 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    margin-top: 47px;
    background-color: #ffffff;
    width: 375px;
    height: 50px;
  }

  .color_1 {
    margin-top: 37px;
    border-radius: 2px;
    background-color: #000000;
    width: 134px;
    height: 5px;
  }

  .block_10 {
    display: flex;
    position: absolute;
    top: 0;
    align-items: flex-start;
    align-self: center;
    flex-direction: row;
    background-color: #ffffff;
    width: 375px;
    height: 61px;
  }

  .tagWrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    margin-left: 15px;
    border-radius: 22px;
    background-color: #5878fa;
    width: 350px;
    height: 44px;
  }

  .tag {
    max-width: 338px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

  .row2 {
    background-color: #fafafa;
    width: 375px;
    height: 812px;
    overflow: hidden;
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 15px;
  }

  .main {
    border-style: solid;
    border-color: #efeef3;
    background-color: #ffffff;
    width: 1px;
    height: 131px;
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 15px;
  }

  .row3 {
    border-style: solid;
    border-radius: 10px;
    border-color: #efeef3;
    background-color: #ffffff;
    width: 355px;
    height: 121px;
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 15px;
  }

  .row4 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .text_1 {
    line-height: 14px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 500;
  }

  .row5 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .txt_2 {
    line-height: 14px;
    white-space: nowrap;
    color: #424242;
    font-size: 14px;
    font-weight: 500;
  }

  .row6 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .phone {
    line-height: 14px;
    white-space: nowrap;
    color: #929292;
    font-size: 14px;
    font-weight: 400;
  }

  .row7 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .text_2 {
    line-height: 14px;
    white-space: nowrap;
    color: #929292;
    font-size: 14px;
    font-weight: 400;
  }

  .row8 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 15px;
  }

  .empty_1 {
    margin-right: 340px;
    width: 0;
    height: 1px;
  }

  .bgWrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 0;
  }

  .bg_1 {
    margin-left: -340px;
    width: 340px;
    height: 1px;
  }

  .row9 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
    margin-top: 15px;
  }

  .div_1 {
    position: relative;
    width: 375px;
    height: 0;
  }

  .normal_div_8 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 1px;
    width: 375px;
  }

  .bg_2 {
    position: relative;
    margin-top: -1px;
    width: 375px;
    height: 1px;
  }

  .block_11 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    margin-top: 72px;
    background-color: #ffffff;
    width: 375px;
    height: 50px;
  }

  .color_2 {
    margin-top: 37px;
    border-radius: 2px;
    background-color: #000000;
    width: 134px;
    height: 5px;
  }

  .block_12 {
    display: flex;
    position: absolute;
    top: 0;
    align-items: flex-start;
    align-self: center;
    flex-direction: column;
    background-color: #ffffff;
    width: 375px;
    height: 86px;
  }

  .group_3 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    margin-top: 14px;
    height: 15px;
  }

  .info_8 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .word_3 {
    margin-top: 1px;
    line-height: 10px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 10px;
    font-weight: 400;
  }

  .info_9 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .txt_3 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #5878fa;
    font-size: 10px;
    font-weight: 400;
  }

  .info_10 {
    margin-top: -1px;
    line-height: 10px;
    white-space: nowrap;
    color: #929292;
    font-size: 10px;
    font-weight: 300;
  }

  .tagWrap_1 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 12px;
    margin-left: 15px;
    border-radius: 22px;
    background-color: #5878fa;
    width: 350px;
    height: 44px;
  }

  .tag_1 {
    max-width: 338px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

  .row10 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    background-color: #ffffff;
    width: 375px;
    height: 88px;
    position: relative;
    margin-top: 15px;
  }

  .normal_div_9 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 17px;
    margin-left: 34px;
  }

  .txt_4 {
    margin-top: 7px;
    margin-right: 232px;
    max-width: 248px;
    height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 19px;
    letter-spacing: 0px;
    white-space: nowrap;
    color: #ffffff;
    font-family: SFProText-Semibold, SF Pro Text;
    font-size: 15px;
    font-weight: 600;
  }

  .block_13 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
  }

  .icon_16 {
    margin-right: 5px;
    width: 17px;
    height: 12px;
  }

  .icon_17 {
    margin-right: 5px;
    width: 16px;
    height: 12px;
  }

  .group_4 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    border-color: rgba(255, 255, 255, 0.35);
    width: 22px;
    height: 11px;
  }

  .colorDiv_1 {
    border-radius: 1px;
    background-color: #ffffff;
    width: 18px;
    height: 7px;
  }

  .dot_5 {
    width: 2px;
    height: 4px;
  }

  .normal_div_10 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 7px;
    margin-left: 17px;
  }

  .icon_18 {
    margin-right: 128px;
    width: 9px;
    height: 18px;
  }

  .word_4 {
    margin-right: 60px;
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-weight: 500;
  }

  .block_14 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-style: solid;
    border-radius: 16px;
    border-color: rgba(151, 151, 151, 0.2);
    background-color: rgba(255, 255, 255, 0.6);
    height: 32px;
  }

  .block_15 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 1px;
    width: 44px;
  }

  .icon_19 {
    width: 19px;
    height: 7px;
  }

  .color_3 {
    margin-right: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    width: 1px;
    height: 18px;
  }

  .group_5 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 41px;
  }

  .icon_20 {
    width: 18px;
    height: 18px;
  }

  .row11 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 15px;
  }

  .icon_21 {
    width: 13px;
    height: 16px;
  }

  .row12 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    position: relative;
    margin-top: 15px;
  }

  .icon_22 {
    width: 15px;
    height: 16px;
  }

  .row13 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .info_11 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row14 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .txt_5 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row15 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .info_12 {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row16 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .text_3 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row17 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .info_13 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row18 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .info_14 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .row19 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .organization {
    line-height: 12px;
    white-space: nowrap;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row20 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .txt_6 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .row21 {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .word_5 {
    line-height: 12px;
    white-space: nowrap;
    color: #fe654d;
    font-size: 12px;
    font-weight: 400;
  }

  .ft {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    height: 20px;
    position: relative;
    margin-top: 15px;
  }

  .desc_3 {
    line-height: 12px;
    white-space: pre;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }
  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    background-color: #fff;
  }

  .footer-content {
    display: flex;
    align-items: center;
    align-self: center;
    flex-direction: row;
    background-color: #ffffff;
    width: 100%;
    height: 58px;
    padding: 0px 10px;
  }

  .add-btn {
    width: 100%;
    height: 44px;
    border-radius: 44px;
    line-height: 20px;
    color: #fff;
    text-align: center;
  }
  .tag {
    color: #ffffff;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    position: absolute;
    margin-top: 12px;
    margin-left: -45px;
  }
</style>



// WEBPACK FOOTER //
// Promotions.vue?2a172d66